import { render, staticRenderFns } from "./TrafficSiteEditForm.vue?vue&type=template&id=90f59aa2"
import script from "./TrafficSiteEditForm.vue?vue&type=script&lang=js"
export * from "./TrafficSiteEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports